import { SVGProps } from "react";

const Warning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={38}
    height={34}
    viewBox="0 0 38 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.8125 25.0833H18.8304M18.8125 19.7083V14.3333M3.48207 32.25H34.1429C35.6865 32.25 36.6482 30.5756 35.8705 29.2423L20.5401 2.96153C19.7683 1.63852 17.8567 1.63852 17.0849 2.96153L1.75452 29.2423C0.97675 30.5756 1.93849 32.25 3.48207 32.25Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Warning;
